import React, { useState } from 'react';
import './Login.css';
import googleIcon from '../Image/Wrapper.png';
import facebookIcon from '../Image/Vector.png';
import { Eye, EyeOff } from "lucide-react";
import coderwinglogo from "../Image/coderwing-logo.png";
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
  
    try {
      const response = await fetch(`${apiUrl}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg || "Login failed");
  
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("isAdmin", data.isAdmin);
  
    
      if (data.isAdmin) {
        window.location.href = "/Dashboard";
      } else {
        window.location.href = "/"; 
      }
  
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="logo-container">
          <div className="logo">
            <img src={coderwinglogo} alt="Coderwing Logo" className='logo-text' />
          </div>
          <button className="signup-top">Sign up</button>
        </div>

        <div className="login-form-container">
          <h1 className="welcome-text">Welcome Back!</h1>
          <p className="subtitle">Sign in to your Coderwing account</p>

          {error && <p className="error-message">{error}</p>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email..."
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter your password..."
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeOff /> : <Eye />}
                </span>
              </div>
              <div className="forgot-password">
                <a href="/forgot-password">Forgot Password?</a>
              </div>
            </div>

            <button type="submit" className="signin-button" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>

            <div className="divider">
              <span>Or</span>
            </div>

            <div className="social-login">
              <button type="button" className="google-btn">
                <img src={googleIcon} alt="Google" />
                Sign in with Google
              </button>
              <button type="button" className="facebook-btn">
                <img src={facebookIcon} alt="Facebook" />
                Sign in with Facebook
              </button>
            </div>

            <div className="signup-prompt">
              Don't have an account? <a href="/Singup">Sign up</a>
            </div>
          </form>
        </div>
      </div>
      <div className="login-right"></div>
    </div>
  );
};

export default Login; 